module.exports = __webpack_public_path__ + "static/img/TR.7577a3c6.svg";